import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { Observable, of } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-engage-move-experience-members-dialog',
    templateUrl: './engage-move-experience-members-dialog.component.html',
    styleUrls: ['./engage-move-experience-members-dialog.component.scss'],
})
export class EngageMoveExperienceMembersDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    experiences: MaxBrainExperience[];

    @Input()
    entityId: string;

    @Input()
    selectedUserId$: Observable<string[]> = of([]);
    selectedUserIds: [{ id: string }];

    @Input()
    title: string;

    @Input()
    label: string;

    get parent() {
        return this.formGroup.get('experienceId');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<EngageMoveExperienceMembersDialogComponent>) {
        super();
    }

    ngOnInit() {
        this._formGroup = this._formBuilder.group({
            experienceId: ['', Validators.required],
        });

        this.selectedUserId$
            .pipe(
                filter((selectedUserIds) => !!selectedUserIds),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((selectedUserIds) => {
                this.selectedUserIds = selectedUserIds.map((id) => ({ id: id })) as [{ id: string }];
            });
    }

    async onMoveMember() {
        this.dialogRef.close({ target: this.parent.value, selectedUserIds: this.selectedUserIds });
    }
}
